module.exports = __webpack_public_path__ + "files/f84dd2e0c65fc20bf332798f74b2e35f.png";